<template>
  <div class="base-data-table" :style="heightStyle">
    <div class="header-wraper" :style="{ paddingRight: hasScroll ? `${scrollbarWidth}px` : '0' }">
      <table class="table-header">
        <tr>
          <td v-for="col in columns" :key="col.code" :class="col.cellStyle" :style="{ minWidth: col.minWidth, width: colWidths[col.code] }">
            <template v-if="col.nameComponent">
              <component :is="mixinHeaderComponent(col.nameComponent)" @eventEmit="eventEmit" :list="list" />
            </template>
            <template v-else>
              <div class="name">{{ col.name }}</div>
              <div v-if="col.sortField" class="sort">
                <p :class="{ active: sortConfig[col.code] === 'asc' }" @click="sort(col.code, 'asc')"><i class="el-icon-caret-top"></i></p>
                <p :class="{ active: sortConfig[col.code] === 'desc' }" @click="sort(col.code, 'desc')"><i class="el-icon-caret-bottom"></i></p>
              </div>
            </template>
          </td>
        </tr>
      </table>
    </div>
    <div ref="contentBody" class="body-wraper" :class="{ 'has-scroll': hasScroll }">
      <table v-if="list && list.length" class="table-body" :class="{ striped: stripRow, highlight: highlightRow }">
        <tr v-for="(row, index) in list" :key="row[keyCode] || index">
          <td v-for="col in columns" :key="col.code" :class="col.cellStyle" :style="{ minWidth: col.minWidth, width: colWidths[col.code] }">
            <template v-if="col.cellComponent">
              <component :is="mixinCellComponent(col.cellComponent)" :row="row" :global-data="globalData" @eventEmit="eventEmit" />
            </template>
            <template v-else-if="col.renderFunc">
              {{ col.renderFunc(row[col.code], row, index, globalData) }}
            </template>
            <template v-else>
              {{ col.code === 'idx' ? index + 1 : row[col.code] }}
            </template>
          </td>
        </tr>
      </table>
      <div class="no-data" v-else>
        {{ noDataTip }}
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import Utils from '@/utils'
const cellMixin = {
  props: {
    row: {
      type: Object,
      required: true
    },
    globalData: {
      type: Object,
      required: false
    },
    eventEmit: {
      type: Function,
      required: false
    }
  }
}
const headerMixin = {
  props: {
    eventEmit: {
      type: Function,
      required: false
    },
    list: {
      type: Array,
      required: false
    }
  }
}

export default {
  name: 'BaseTable',
  props: {
    stripRow: {
      type: Boolean,
      default () {
        return true
      }
    },
    highlightRow: {
      type: Boolean,
      default () {
        return false
      }
    },
    columns: {
      type: Array,
      required: true,
      default () {
        return [
          // {
          //   name: '列名',
          //   sortField: true,
          //   minWidth: '60px',
          //   flexWidth: 1,
          //   code: 'code',
          //   renderFunc: undefined,
          //   cellComponent: undefined,
          //   cellStyle: undefined
          // }
        ]
      }
    },
    sortConfig: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    keyCode: {
      type: String,
      required: false,
      default () {
        return 'id'
      }
    },
    list: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    maxHeight: {
      type: String,
      required: false,
      default () {
        return undefined
      }
    },
    noDataTip: {
      type: String,
      required: false,
      default () {
        return 'no data'
      }
    },
    globalData: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      hasScroll: false
    }
  },
  computed: {
    scrollbarWidth () {
      return this.$store.state.scrollbarWidth
    },
    colWidths () {
      let cols = this.columns.map(item => ({
        code: item.code,
        width: item.flexWidth || 1
      }))
      const totalWidth = _.sumBy(cols, o => o.width)
      cols = cols.map(t => ({
        code: t.code,
        width: `${(t.width * 100 / totalWidth).toFixed(1)}%`
      }))
      const colWidths = {}
      cols.forEach(col => {
        colWidths[col.code] = col.width
      })
      return colWidths
    },
    heightStyle () {
      const heightStyle = {
      }
      if (this.maxHeight) {
        heightStyle.maxHeight = this.maxHeight
      }
      return heightStyle
    },
    rowCount () {
      return this.list.length
    }
  },
  watch: {
    rowCount (val) {
      this.checkHasScroll()
    },
    maxHeight (val) {
      this.checkHasScroll()
    }
  },
  mounted () {
    const that = this
    that.hasScroll = that.$refs.contentBody.scrollHeight > that.$refs.contentBody.clientHeight
    this.checkHasScroll = _.debounce(() => {
      that.hasScroll = that.$refs.contentBody.scrollHeight > that.$refs.contentBody.clientHeight
    }, 50)
    Utils.EventBinder.bind(window, 'resize', that.checkHasScroll)
  },
  beforeDestroy () {
    Utils.EventBinder.unbind(window, 'resize', this.checkHasScroll)
  },
  methods: {
    sort (code, type) {
      if (this.sortConfig[code] !== type) {
        this.$emit('sort', {
          code,
          type
        })
      }
    },
    eventEmit (eventName, data) {
      this.$emit(eventName, data)
    },
    mixinCellComponent (componentObject) {
      return Vue.extend({
        mixins: [cellMixin],
        ...componentObject
      })
    },
    mixinHeaderComponent (componentObject) {
      return Vue.extend({
        mixins: [headerMixin],
        ...componentObject
      })
    }
  }
}
</script>
